const LIGHT_THEME = "LIGHT";
const DARK_THEME = "DARK";


export function getRailTheme(index){
    if (index % 2 == 0){
        return LIGHT_THEME;
    }
    return DARK_THEME;
}